/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MediaImageGeneratePathParams,
	MediaImageGenerateRequest,
	MediaImageGenerateResponse,
} from '../types/MediaImageGenerate'

/**
 * POST /media/:organisation/images/generate
 * @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::generate
 */
export async function mediaImageGenerate(
	organisation: MediaImageGeneratePathParams['organisation'],
	data: MediaImageGenerateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MediaImageGenerateResponse>> {
	return axiosInstance.post(`/media/${organisation}/images/generate`, data, config)
}
